import React from 'react';
import { iconSizer } from "../../../../../icons2022/iconSizer";
import { PictureIcon16Solid } from "../../../../../icons2022/FileTypePictureIcon/PictureIcon16Solid";
import { PictureIcon20Solid } from "../../../../../icons2022/FileTypePictureIcon/PictureIcon20Solid";
import { PictureIcon24Solid } from "../../../../../icons2022/FileTypePictureIcon/PictureIcon24Solid";
export var PictureIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(PictureIcon16Solid, null);
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(PictureIcon20Solid, null);
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(PictureIcon24Solid, null);
  }
}, 'PictureIcon');